import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { SsoScreen } from '@/screens/accounts/SCR-106-107-sso-mfa'

// SCR-106 Single sign-on (accounts area). Discovery itself is the federation area's POST /esm/v1/sso/discover;
// a failed SSO round trip comes back here as ?error=<code>.
export const Route = createFileRoute('/_public/sso')({
  validateSearch: z.object({
    email: z.string().max(200).optional().catch(undefined),
    next: z.string().max(2000).optional().catch(undefined),
    error: z.string().max(60).optional().catch(undefined),
  }),
  component: function Sso() {
    return <SsoScreen search={Route.useSearch()} />
  },
})
